import { render } from "./ScansView.vue?vue&type=template&id=aa5ae7f6"
import script from "./ScansView.vue?vue&type=script&lang=js"
export * from "./ScansView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__